import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";
import { ReactNode } from "react";

type Props = {
  id: string;
  label: string;
  selectedValues: Array<string> | undefined;
  onChange: (event: SelectChangeEvent<Array<string>>) => void;
  handleSelectedChipRemoval: (value: string) => void;
  options: Array<string>;
  renderOption?: (value: string) => ReactNode;
  renderSelectedChip?: (value: string) => ReactNode;
  touchedText?: string | undefined;
  errors?: boolean;
};

function MultiSelect({
  id,
  label,
  selectedValues,
  onChange,
  handleSelectedChipRemoval,
  options,
  renderOption,
  renderSelectedChip,
  touchedText,
  errors,
}: Props) {
  return (
    <FormControl fullWidth error={errors}>
      <InputLabel variant="standard" id={id}>
        {label}
      </InputLabel>
      <Select
        variant="standard"
        labelId={`${id}-label`}
        id={id}
        name={id}
        multiple
        value={selectedValues}
        onChange={(event) => onChange(event)}
        renderValue={(selected) => {
          const selectedArray = Array.isArray(selected) ? selected : [];
          return (
            <Box
              sx={{ display: "flex", flexWrap: "wrap", padding: 0.5, gap: 0.5 }}
            >
              {selectedArray.map((value) => (
                <Chip
                  data-testid={`${value}-test-id`}
                  color="secondary"
                  key={value}
                  sx={{
                    fontWeight: 550,
                  }}
                  label={renderSelectedChip ? renderSelectedChip(value) : value}
                  onDelete={() => handleSelectedChipRemoval(value)}
                  deleteIcon={
                    <Cancel onMouseDown={(event) => event.stopPropagation()} />
                  }
                />
              ))}
            </Box>
          );
        }}
      >
        {options.map((value) => (
          <MenuItem key={value} value={value}>
            <Checkbox checked={selectedValues?.includes(value)} />
            {renderOption ? (
              <>{renderOption(value)}</>
            ) : (
              <ListItemText primary={value} />
            )}
          </MenuItem>
        ))}
      </Select>
      {touchedText ? <FormHelperText>{touchedText}</FormHelperText> : null}
    </FormControl>
  );
}

export default MultiSelect;
